<template>
  <v-content>
    <v-alert
      v-if="showCompanyLockedBanner"
      type="warning"
      border="left"
      colored-border
      tile
      prominent
      class="ma-0 rounded-0 mx-3"
    >
      <div class="text-h6 font-weight-medium">
        {{ $t("company_locked_title") }}
      </div>
      <div class="mt-2 text-body-1">
        {{ companyLockedBody }}
      </div>
    </v-alert>
    <router-view />

    <dashboard-core-footer />
  </v-content>
</template>

<script>
import {
  getAuthUserCompany,
  isAuthUserCompanyLocked
} from "../../../../utils/company-locked";

export default {
  name: "DashboardCoreView",
  components: {
    DashboardCoreFooter: () => import("./Footer")
  },
  computed: {
    showCompanyLockedBanner() {
      return isAuthUserCompanyLocked(this.$auth);
    },
    companyLockedBody() {
      const company = getAuthUserCompany(this.$auth);
      if (!company) return this.$t("company_locked_fallback");
      const info =
        company.locked_info != null ? String(company.locked_info).trim() : "";
      return info || this.$t("company_locked_fallback");
    }
  }
};
</script>
